module.exports = __webpack_public_path__ + "static/media/sort.5691d96d.svg";